function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { NotImplementationExeption } from 'internals/exceptionHandler';
import { webMobileMode, getFileName } from 'internals/helpers';
import { functionValidator, userValidator } from 'internals/validators';
var GeneralEventTrackingDispatcher = /*#__PURE__*/function () {
  function GeneralEventTrackingDispatcher(_ref) {
    var userFetcher = _ref.userFetcher;
    _classCallCheck(this, GeneralEventTrackingDispatcher);
    functionValidator(userFetcher);
    this.validUserFetcher = function () {
      return userValidator(userFetcher());
    };
    var user = this.validUserFetcher();
    this.user = user;
    this.webMobileMode = webMobileMode;
  }
  return _createClass(GeneralEventTrackingDispatcher, [{
    key: "createMainEventProperties",
    value: function createMainEventProperties(state) {
      return {
        uri: window.location.href,
        current_page: state.getIn(['route', 'topLevelRouteName']),
        referrer: window.document.referrer
      };
    }
  }, {
    key: "logWithDefaultProps",
    value: function logWithDefaultProps() {
      throw new NotImplementationExeption({
        message: 'logWithDefaultProps not implemented',
        fileName: getFileName(__filename)
      });
    }
  }, {
    key: "logWithDefaultEventProps",
    value: function logWithDefaultEventProps() {
      throw new NotImplementationExeption({
        message: 'logWithDefaultEventProps not implemented',
        fileName: getFileName(__filename)
      });
    }
  }, {
    key: "setUserProperties",
    value: function setUserProperties() {
      throw new NotImplementationExeption({
        message: 'setUserProperties not implemented',
        fileName: getFileName(__filename)
      });
    }
  }, {
    key: "setDefaultUserProperties",
    value: function setDefaultUserProperties() {
      throw new NotImplementationExeption({
        message: 'setDefaultUserProperties not implemented',
        fileName: getFileName(__filename)
      });
    }
  }, {
    key: "identify",
    value: function identify() {
      throw new NotImplementationExeption({
        message: 'identify not implemented',
        fileName: getFileName(__filename)
      });
    }
  }]);
}();
export { GeneralEventTrackingDispatcher as default };